import React, { useEffect, useState } from 'react'
import { Container, FormGroupCustom, FormLabelCustom, InputDateInicial } from './style'
import SelectWithSearch from '../../../../Components/SelectWithSearch'
import { Form } from 'react-bootstrap'
import { getOrganDataList } from '../../../../services/organ'
import { getAllServices } from '../../../../services/flow'

const FiltersFlow = ({ setFilters, filters, setServicesList, servicesList, serviceSelected, setServiceSelected }: any) => {
  const [orgaoList, setOrgaoList] = useState<any>(null);
  const [loadingOrgao, setLoadingOrgao] = useState<boolean>(false);
  const [orgaoAll, setOrgaoAll] = useState<any>();
  const [service, setService] = useState<any>(null);
  const [loadingServico, setLoadingServico] = useState<boolean>(false);
  const [organSelected, setOrgaoSelected] = useState<number>(0);
  const [organSlugSelected, setOrgaoSlugSelected] = useState<string>('');
  const [orgao, setOrgao] = useState<any>(null);

  const handleGetById = (slug: string, items: any) => {
    if (slug) {
      return items.filter((item) => item.slug === slug);
    }
  }

  const handleSelectOrgao = (value: { label: string, value: string }) => {
    if (value) {
      let [orgao] = handleGetById(value.value, orgaoAll);
      setOrgao(value);
      setOrgaoSelected(orgao.id);
      setOrgaoSlugSelected(orgao.slug);
      onRemoveServiceValues();
      setFilters({ ...filters, orgao: value, organSelected: orgao.id, organSlugSelected: orgao.sigla ? orgao.sigla : '' });
    }
  }

  const setOrgaoValueFormatted = (values) => {
    if (values) {
      let orgaoOptions = values.map((value) => ({
        label: value.nome,
        value: value.slug,
      }));
      setOrgaoList(orgaoOptions);
    }
  }

  useEffect(() => {
    const getOrgans = async () => {
      const tokenSSO: string | null = localStorage.getItem('gov_access_token');
      try {
        setLoadingOrgao(true);
        const { data } = await getOrganDataList(tokenSSO);
        if (data) {
          setOrgaoValueFormatted(data);
          setOrgaoAll(data);
        }

      } catch (error) {
        console.log(error);

      } finally {
        setLoadingOrgao(false);
      }
    };
    getOrgans();
  }, []);

  const booleanOptions = [
    { value: true, label: 'Sim' },
    { value: false, label: 'Não' }
  ];

  const booleanOptionsStatus = [
    { value: true, label: 'Ativo' },
    { value: false, label: 'Inativo' },
  ];

  const handleChangeDataInicial = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    let value = e.target.value;
    setFilters({
      ...filters,
      createdData: value
    })
  }

  const handleSelectService = (value: { label: string, value: string }) => {
    if (value) {
      setServiceSelected(value.value);
      setService(value);
      setFilters({ ...filters, servico_slug: value })
    }
  }

  const setServicoValueFormatted = (values) => {
    if (values) {
      let serviceOptions = values.map((value) => ({
        label: value.titulo,
        value: value.slug,
      }));
      setServicesList(serviceOptions);
      if (serviceSelected) {
        const service = handleGetById(serviceSelected, serviceOptions);
        if (service?.length) {
          setService({ label: service[0].label, value: service[0].value });
        }
      }
    }
  }

  const getServices = async (orgaoSlug?: string) => {
    setLoadingServico(true);
    try {
      const { data } = await getAllServices(orgaoSlug);
      if (data) {
        setServicoValueFormatted(data);
        return data;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingServico(false);
    }
  }

  const onRemoveServiceValues = () => {
    setServicesList([]);
    setServiceSelected('');
    setService(null);
  }

  useEffect(() => {
    if (organSelected && organSlugSelected) {
      getServices(organSlugSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organSelected, organSlugSelected]);

  return (
    <Container>
      <FormGroupCustom>
        <FormLabelCustom>
          Status
        </FormLabelCustom>
        <SelectWithSearch
          name='filtro_ativo'
          options={booleanOptionsStatus}
          isDisabled={!booleanOptions || loadingOrgao}
          value={filters.filtro_ativo}
          onChange={(selectedOption) => setFilters({
            ...filters,
            filtro_ativo: selectedOption
          })}
          placeholder="---------"
        />
      </FormGroupCustom>

      <FormGroupCustom>
        <FormLabelCustom>
          Modelo
        </FormLabelCustom>
        <SelectWithSearch
          name='Modelo'
          options={booleanOptions}
          isDisabled={!booleanOptions || loadingOrgao}
          value={filters.model}
          onChange={(selectedOption) => setFilters({
            ...filters,
            model: selectedOption
          })}
          placeholder="---------"
        />
      </FormGroupCustom>

      <FormGroupCustom>
        <FormLabelCustom>
          Data de criação
        </FormLabelCustom>
        <InputDateInicial
          type={"date"}
          placeholder="Data de criação"
          value={filters.createdData}
          disabled={false}
          onChange={handleChangeDataInicial}
        />
      </FormGroupCustom>

      <FormGroupCustom>
        <FormLabelCustom>
          Órgão
        </FormLabelCustom>
        <SelectWithSearch
          name='orgao'
          options={orgaoList}
          isDisabled={!orgaoList || loadingOrgao}
          value={filters.orgao}
          onChange={handleSelectOrgao}
          placeholder="Selecione ou digite o nome do órgão"
        />
      </FormGroupCustom>


      <FormGroupCustom >
        <FormLabelCustom>
          Serviço
        </FormLabelCustom>
        <SelectWithSearch
          name='servicos'
          value={filters.servico_slug}
          isDisabled={!servicesList?.length || loadingServico}
          onChange={handleSelectService}
          options={servicesList}
          placeholder={!servicesList?.length || loadingServico ? 'Selecione um orgão para liberar o campo' : "Selecione ou digite o nome do serviço"}
        />
      </FormGroupCustom>

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Título</FormLabelCustom>
        <Form.Control
          type="text"
          required
          value={filters.title}
          onChange={(event) => setFilters({ ...filters, title: event.target.value })}
        />
      </FormGroupCustom>
    </Container>
  )
}

export default FiltersFlow